
import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { User } from 'lucide-react';
import { useImageUrl } from '@/hooks/useImageUrl';

interface NotificationAvatarProps {
  photoUrl?: string;
  username?: string;
  sourceType?: string;
  shouldBlur?: boolean;
}

const NotificationAvatar: React.FC<NotificationAvatarProps> = ({
  photoUrl,
  username,
  sourceType = 'user',
  shouldBlur = false
}) => {
  // Use async hook to properly regenerate expired signed URLs
  const { url: optimizedPhotoUrl, isLoading } = useImageUrl(photoUrl, 'avatar');

  const getAvatarFallback = () => {
    if (username) {
      return username.substring(0, 2).toUpperCase();
    }
    return 'N/A';
  };

  return (
    <div className="flex-shrink-0 relative">
      <Avatar className={`h-10 w-10 border-2 border-white/20 ${shouldBlur ? 'blur-[8px]' : ''} ${isLoading ? 'animate-pulse' : ''}`}>
        {optimizedPhotoUrl && !isLoading ? (
          <AvatarImage 
            src={optimizedPhotoUrl} 
            alt={username || 'User'} 
            className="object-cover" 
          />
        ) : (
          <AvatarFallback className="bg-black/40 text-white">
            {sourceType === 'system' ? <User size={16} /> : getAvatarFallback()}
          </AvatarFallback>
        )}
      </Avatar>
      {sourceType === 'system' && (
        <div className="absolute -bottom-1 -right-1 bg-yellow-500 rounded-full p-1 border border-black">
          <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-black">
            <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
          </svg>
        </div>
      )}
    </div>
  );
};

export default NotificationAvatar;
